var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.step <= _vm.steps)?_c('nav',{staticClass:"quiz-nav isActive"},[_c('div',{},[_c('p',{staticClass:"mb-1 text-center overview"},[_vm._v(_vm._s(_vm.step)+"/"+_vm._s(_vm.steps))]),_vm._v(" "),_c('ProgressBar',{attrs:{"index":_vm.step,"count":_vm.steps}})],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04d1d206","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 38
// module chunks = 0